/* eslint-disable */

import Auth from './Auth';

export default {
    Auth: Auth
}